import {map} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {ApiService} from './api';

@Injectable({providedIn: 'root'})
export class ThirdPartyUasService {
  path: string = '/api';
  constructor(private apiService: ApiService) {}

  getUasByType(thirdPartyId: string, uaPath: string) {
    return this.apiService.get<{ data: { records: any[] } }>(`${this.path}/v2/third_parties/${thirdPartyId}/${uaPath}`)
      .pipe(
        map(response => response?.data?.records)
      );
  }

  getUasByCategory(thirdPartyId: string, categoryId: string) {
    const uaPath = 'summary_upas';
    return this.apiService
      .get(`${this.path}/v2/third_parties/${thirdPartyId}/${uaPath}?category_type=${categoryId}`)
      .pipe(
        map((response: any) => {
          return response.data.records;
        }),
      );
  }

  getUtas(thirdPartyId: number, utaIds: any[]) {
    const utaParam = utaIds.join(',');
    return this.apiService
      .get(`${this.path}/third_parties/${thirdPartyId}/summary_utas?ids=${utaParam}`);
  }
}
